import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { find } from 'ramda';
import { IBindingCallback1 } from '../../common/models/callback';
import CheckboxList from '../CheckboxList';
import styles from './styles.module.scss';
import { Node } from '../../common/models/common/Node';
import { FavoritesFilterOption } from '../../common/enums/FavoritesFilterOption';

interface IProps {
  onFilter: IBindingCallback1<FavoritesFilterOption>;
  value: FavoritesFilterOption;
}

const FavoritesFilter: FunctionComponent<IProps> = ({ onFilter, value }) => {
  const options: Node[] = [{
    label: <FormattedMessage id="myFavorites" defaultMessage="My Favorites" />,
    value: FavoritesFilterOption.My
  }, {
    label: <FormattedMessage id="myTeamFavorites" defaultMessage="My team's favorites" />,
    value: FavoritesFilterOption.Team
  }];

  const defaultOption = find(opt => opt.value === value, options)?.value;

  return (
    <div className={styles.favoritesFilter}>
      <div className={styles.label}>
        <FormattedMessage id="showOnly" defaultMessage="Show only: " />
      </div>
      <CheckboxList
        total={options.length}
        items={options}
        onSelect={([selected]) => onFilter(selected as FavoritesFilterOption)}
        defaultChecked={defaultOption ? [defaultOption] : []}
      />
    </div>
  );
};

export default FavoritesFilter;
